import(/* webpackMode: "eager" */ "/vercel/path0/app/dsu/page.tsx");
